export default __webpack_public_path__ + "static/media/player-01@2x.7ad4de99.jpg";